import {Link} from "react-router-dom";
import className from "classnames/bind";
import {Button, FontAwesomeIcon} from "~/components";
import style from "../style/Competitor.module.scss";

const cn = className.bind(style);

/** Panel CTA khi gói chưa có tính năng Phân tích đối thủ (can_competitor — Pro/Max). */
function UpgradeCta() {
	return (
		<div className={cn('ctaPanel')}>
			<FontAwesomeIcon icon="fa-light fa-lock" style={{fontSize: 34, color: '#9ca3af'}} />
			<h3 style={{margin: '14px 0 6px', fontSize: 16, fontWeight: 700}}>Phân tích đối thủ</h3>
			<p style={{color: '#6b7280', maxWidth: 560, margin: '0 auto 18px'}}>
				So sánh điểm SEO on-page với đối thủ, tìm chủ đề đối thủ phủ mà bạn còn thiếu (Content Gap
				nhiều đối thủ) và ma trận độ phủ từ khoá từ dữ liệu Search Console thật.
				Tính năng thuộc gói Chuyên nghiệp trở lên.
			</p>
			<Link to="/subscription">
				<Button primary leftIcon={<FontAwesomeIcon icon="fa-light fa-rocket" />}>Xem gói & nâng cấp</Button>
			</Link>
		</div>
	);
}

export default UpgradeCta;
